import { render, staticRenderFns } from "./MeetingReviews.vue?vue&type=template&id=71d55e42&"
import script from "./MeetingReviews.vue?vue&type=script&lang=js&"
export * from "./MeetingReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports